<nav class="nav-menu">
    <ul class="nav-menu__items">
        @for (item of navItems; track $index) {
            <li class="nav-menu__item" routerLinkActive="nav-menu__item--active">
                <a [routerLink]="['/', item.route]"
                   class="nav-menu__link"
                   routerLinkActive="nav-menu__link--active">
                    {{ item.text }}
                </a>
            </li>
        }
    </ul>
</nav>
